// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"bacc4c95","583":"4faee64c"}[chunkId] + ".chunk.js";
};